<template>
  <div class="loading-screen justify-content-center align-items-center">
    <b-spinner
      class="spinner"
      style="width: 20rem; height: 20rem; color: white"
      label="Large Spinner"
    ></b-spinner>
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
};
</script>

<style scoped>
.loading-screen {
  display: flex;
  position: fixed;
  width: 100vw;
  height: 100vh;
  right: 0;
  top: 0;
  z-index: 2010;
  background-color: rgba(0, 0, 0, 0.8);
}

@media (max-width: 930px) {
  .spinner {
    width: 15rem !important;
    height: 15rem !important;
  } 
}
</style>
